import React, { useEffect, useState, useMemo } from "react";

import {
  Avatar,
  Badge,
  Box,
  Button,
  Card,
  CardContent,
  CardMedia,
  Grid,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Snackbar,
  Stack,
  Typography
} from "@mui/material";
import dayjs from "dayjs";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Getrequestcall } from "../../request/Getrequest";
import { Postrequestcall } from "../../request/Postrequest";
import DnsIcon from "@mui/icons-material/Dns";
import { BIBlue } from "../../assets/helpers";
import {
  GET_CLIENT_APP_LIST_COUNT_DETAILS,
  UPDATE_EMPLOYEE_LICENSES_IS_PING_FLAG
} from "../../constant/Apipath";
import {
  fetchClientEmployeeAppsLicensesDetails,
  normalizeClientEmployeeAppsLicensesResponse
} from "../utils/clientEmployeeAppsLicenses";

import { Home as HomeIcon, Notifications as NotificationsIcon } from "@mui/icons-material";
import BuilderIcon from "../../assets/images/marker_yellow.png";

import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import ChatIcon from "@mui/icons-material/Chat";
import PushPinIcon from "@mui/icons-material/PushPin";
import SupportIcon from "@mui/icons-material/Support";
import VideocamIcon from "@mui/icons-material/Videocam";
import PendingIcon from "@mui/icons-material/Pending";
import RequestQuoteIcon from "@mui/icons-material/RequestQuote";

import PhotoIcon from "@mui/icons-material/Photo";
import AdsClickIcon from "@mui/icons-material/AdsClick";
import TrackChangesIcon from "@mui/icons-material/TrackChanges";
import PsychologyIcon from "@mui/icons-material/Psychology";
import SavedSearchIcon from "@mui/icons-material/SavedSearch";
import ShoppingBagIcon from '@mui/icons-material/ShoppingBag';
import FactCheckIcon from "@mui/icons-material/FactCheck";
import HealthAndSafetyIcon from "@mui/icons-material/HealthAndSafety";
import QueryStatsIcon from "@mui/icons-material/QueryStats";
import CalculateIcon from "@mui/icons-material/Calculate";
import FolderIcon from "@mui/icons-material/Folder";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import SettingsVoiceIcon from "@mui/icons-material/SettingsVoice";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import EditIcon from "@mui/icons-material/Edit";

import Loader from "../../common/Loader";
import PictureViewer from "../../common/PictureViewer";
import ClientHomeEditModal from "./ClientHomeEditModal";
import NoLicenseScreen from "../clientLayout/NoLicenseScreen";
import { ClientEnglishFallback } from "../constant/ClientEnglishFallback";
import { useDispatch } from "react-redux";
import { setLicences } from "../../redux/actions/actions";
import DashboardCard from "./DashboardCard";
function ClientHome() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { loginData, selectedClientData, multiLanguageData, clientLicenses, clientPictureBoard, noLicenseAccess } =
    useSelector((state) => state?.main);

  const [appLicence, setAppLicence] = useState([]);
  const [appListData, setAppListData] = useState([]);
  const [pictureBoardData, setPictureBoardData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showEditModule, setShowEditModule] = useState(false);
  const [sortBy, setSortBy] = useState(true);
  const [pictureViewerOpen, setPictureViewerOpen] = useState(false);
  const [pictureViewIndex, setPictureViewIndex] = useState(0);
  const [allRoutes, setAllRoutes] = useState([]);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const LANGUAGE = ClientEnglishFallback.ClientHome(multiLanguageData?.ClientHome || {});

  const {
    TEXT_NO_PICTURE_ADDED,
    TEXT_EXPENSES,
    TEXT_PENDING_APPROVAL,
    TEXT_TIMESHEETS,
    TEXT_MY_APPLICATIONS,
    TEXT_SORT_BY,
    TEXT_ALPHABETICAL,
    TEXT_RECENTLY_USED,
    TEXT_NO_LICENSES_FOUND,
    TEXT_PICTURE_BOARD,
    TEXT_EDIT_HOME
  } = LANGUAGE;

  const totalActiveLicenses = useMemo(() => {
    if (selectedClientData?.Licenses && Array.isArray(selectedClientData.Licenses)) {
      return selectedClientData.Licenses.reduce(
        (acc, curr) => acc + (curr.TotalNumberOfActiveLicenses || 0),
        0
      );
    }
    return 0;
  }, [selectedClientData]);

  useEffect(() => {
    if (selectedClientData?.ClientId && !noLicenseAccess) {
      getInitialData();
      setLoading(true);
      handleSetSortBy("notTrue"); //The code is working dont touch this line
    }
  }, [selectedClientData, noLicenseAccess]);

  const getInitialData = async () => {
    setLoading(true);
    await handleSetAppLicence();
    await getPictureBoardData();
    await getClientAppListCountData();
    setLoading(false);
  };

  const handleSetAppLicence = () => {
    if (clientLicenses.status === 200) {
      const appLicenceData = clientLicenses?.data?.data;

      const sortedAppLicenceData = appLicenceData?.sort((a, b) => {
        // First, sort by IsPin (pinned apps first)
        if (b.IsPin !== a.IsPin) {
          return b.IsPin - a.IsPin;
        }
        // Then, sort alphabetically by AppName
        return a.AppName.localeCompare(b.AppName);
      });

      let allRoutes = sortedAppLicenceData?.map((item) => {
        return item.AppName.replace(/ /g, "-").toLowerCase();
      });
      setAllRoutes([...allRoutes]);
      setAppLicence(sortedAppLicenceData);
    }
  };

  const getAppLicence = async () => {
    try {
      let appLicenceResponse = await fetchClientEmployeeAppsLicensesDetails(
        selectedClientData?.ClientId,
        selectedClientData?.ClientEmployeeId,
        loginData?.accessToken
      );
      if (appLicenceResponse.status === 200) {
        const normalizedResponse = normalizeClientEmployeeAppsLicensesResponse(appLicenceResponse);
        const appLicenceData = normalizedResponse?.data?.data;

        const sortedData = appLicenceData.sort((a, b) => {
          return new Date(b.recentUsedAppDate) - new Date(a.recentUsedAppDate);
        });

        let allRoutes = sortedData?.map((item) => {
          return item.AppName.replace(/ /g, "-").toLowerCase();
        });
        setAllRoutes([...allRoutes]);
        setAppLicence(sortedData);
        dispatch(setLicences(normalizedResponse));
      } else {
        console.log("getAppLicence-> Error In App Licence Data");
      }
    } catch (error) {
      console.log("getAppLicence-> Error Getting App Licence Data: ", error);
    }
  };

  const getPictureBoardData = async () => {
    try {
      setPictureBoardData(clientPictureBoard[0]);
    } catch (error) {
      console.log("getPictureBoardData-> Error Getting Pictureboard Data: ", error);
    }
  };

  const getClientAppListCountData = async () => {
    try {
      const appListCountResponse = await Getrequestcall(
        GET_CLIENT_APP_LIST_COUNT_DETAILS +
        `${selectedClientData?.ClientId}/${selectedClientData?.ClientEmployeeId}`,
        loginData?.accessToken
      );
      if (appListCountResponse.status === 200) {
        setAppListData(appListCountResponse?.data?.data[0]);
      } else {
        console.log("getClientAppListCountData-> Error Getting Client App List Count Data");
      }
    } catch (error) {
      console.log("getClientAppListCountData-> Error Getting Client App List Count Data: ", error);
    }
  };

  const whichIcon = (iconName, clientColor) => {
    switch (iconName) {
      case "Home":
        return <HomeIcon sx={{ color: clientColor }} />;
      case "Safety Incidents":
        return <HealthAndSafetyIcon sx={{ color: clientColor }} />;
      case "Support Requests":
        return <SupportAgentIcon sx={{ color: clientColor }} />;
      case "Safety Observations":
        return <SupportIcon sx={{ color: clientColor }} />;
      case "Expenses":
        return <RequestQuoteIcon className="menu-icons" sx={{ color: clientColor }} />;
      case "Change Tracker":
        return <TrackChangesIcon sx={{ color: clientColor }} />;
      case "Site Activity Reports":
        return <QueryStatsIcon sx={{ color: clientColor }} />;
      case "Coaching":
        return <PsychologyIcon sx={{ color: clientColor }} />;
      case "Site Estimates":
        return <CalculateIcon sx={{ color: clientColor }} />;
      case "Communicator":
        return <ChatIcon sx={{ color: clientColor }} />;
      case "Timesheets":
        return <CalendarMonthIcon sx={{ color: clientColor }} />;
      case "Actions":
        return <AdsClickIcon sx={{ color: clientColor }} />;
      case "Chat":
        return <ChatIcon sx={{ color: clientColor }} />;
      case "Take5":
        return <SettingsVoiceIcon sx={{ color: clientColor }} />;
      case "Site Filing":
        return <FolderIcon sx={{ color: clientColor }} />;
      case "Quality Control":
        return <FactCheckIcon sx={{ color: clientColor }} />;
      case "Notifications":
        return <NotificationsIcon sx={{ color: clientColor }} />;
      case "BuildID":
        return <img loading="lazy" src={BuilderIcon} height={25} width={20} />;
      case "Work Package":
        return <DnsIcon sx={{ color: clientColor }} />;

      case "Videos":
        return <VideocamIcon sx={{ color: clientColor }} />;
      case "Client Tutorial Video":
      case "Client Tutorial Videos":
        return <VideocamIcon sx={{ color: clientColor }} />;
      case "picture-board":
        return <PhotoIcon sx={{ color: clientColor }} />;

      case "Inspections":
        return <SavedSearchIcon sx={{ color: clientColor }} />;
      case "Fixed Assets":
        return <ShoppingBagIcon sx={{ color: clientColor }} />;
      default:
        return <PendingIcon sx={{ color: clientColor }} />;
    }
  };

  const handleNavTo = async (path, licence) => {
    const formattedPath = path.replace(/ /g, "-").toLowerCase();
    if (path === "picture-board" || path === "Picture Board") {
      navigate(`/client/${selectedClientData?.ClientId}/${formattedPath}`);
      return;
    } else if (path === "expenses" || path === "timesheets") {
      licence = appLicence?.find((item) => item.AppName.toLowerCase() === path);
      if (!licence) {
        setSnackbarOpen(true);
        return;
      }
    }
    const obj = {
      Id: 0,
      ClientId: licence?.ClientId,
      EmployeeId: licence?.EmployeeId,
      AppId: licence?.AppId,
      IsPin: licence?.IsPin,
      ModifiedBy: loginData?.userInformation?.UserId
    };

    try {
      await Postrequestcall(UPDATE_EMPLOYEE_LICENSES_IS_PING_FLAG, obj, loginData?.accessToken);
    } catch (error) {
      console.log("handleNavTo-> Error When Updating Employee Licenses Pin: ", error);
    }

    if (allRoutes?.includes(formattedPath)) {
      navigate(`/client/${selectedClientData?.ClientId}/${formattedPath}`);
    }
  };

  const handleShowEditModule = () => {
    setShowEditModule(true);
  };
  const handleHideEditModule = async (refresh) => {
    if (refresh === true) {
      window.dispatchEvent(new CustomEvent("refreshAppLicence", {}));
      await getAppLicence();
    }
    setShowEditModule(false);
  };

  const handleSetSortBy = (type) => {
    if (type === "notTrue") {
      return;
    }
    setSortBy(type);
    sortData(type === true ? "alphabetically" : "Recently Used");
  };

  const sortData = (type) => {
    if (type === "alphabetically") {
      const sortedData = appLicence.sort((a, b) => {
        return a.AppName.localeCompare(b.AppName);
      });
      setAppLicence(sortedData);
    } else if (type === "Recently Used") {
      const sortedData = appLicence.sort((a, b) => {
        return new Date(b.recentUsedAppDate) - new Date(a.recentUsedAppDate);
      });
      setAppLicence(sortedData);
    }
  };

  if (noLicenseAccess) {
    return (
      <NoLicenseScreen
        clientColor={selectedClientData?.AccentColor || selectedClientData?.ClientColor}
        organizationName={selectedClientData?.OrganizationName}
      />
    );
  }

  if (loading) {
    return <Loader fullScreen clientColor={selectedClientData?.ClientColor} />;
  }

  const onImagePreview = (index) => {
    setPictureViewerOpen(true);
    setPictureViewIndex(index);
  };

  const pinnedApps = appLicence?.filter((licence) => licence.IsPin);

  let cardData = [
    {
      title: TEXT_EXPENSES,
      count: appListData?.expensesCount,
      onClick: () => handleNavTo("expenses")
    },
    {
      title: TEXT_TIMESHEETS,
      count: appListData?.timesheetsCount,
      onClick: () => handleNavTo("timesheets")
    },
    {
      title: TEXT_PICTURE_BOARD,
      count: appListData?.picturesBoardCount,
      onClick: () => handleNavTo("picture-board")
    }
  ];

  if (selectedClientData?.IsAdmin === 1) {
    cardData = [
      ...cardData,
      {
        title: "Licenses",
        count: totalActiveLicenses,
        onClick: undefined,
        subtitle: "Active Licenses"
      }
    ];
  }

  return (
    <>
      {appLicence?.length > 0 ? (
        <>
          <div>
            <Grid container spacing={2}>
              {appLicence.findIndex((app) => app.AppName === "Picture Board") !== -1 &&
                pictureBoardData?.fileUrl && (
                  <Grid size={{ xs: 12, lg: 6, xl: 6 }}>
                    <Card variant="outlined" style={{ width: "100%", borderRadius: "18px" }}>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          cursor: "pointer",
                          padding: "5px"
                        }}
                        onClick={() => handleNavTo("picture-board")}>
                        <Typography sx={{ fontWeight: "300", fontSize: "large", marginLeft: "10px" }} variant="h5">
                          {TEXT_PICTURE_BOARD}
                        </Typography>
                        <IconButton>
                          <ArrowForwardIosIcon style={{ fontSize: "18px" }} />
                        </IconButton>
                      </div>
                      {pictureBoardData?.fileUrl ? (
                        <CardMedia
                          onClick={() => onImagePreview(0)}
                          sx={{ height: 250, objectFit: "contain" }}
                          image={pictureBoardData?.fileUrl}
                          title="Pictureboard Image"
                        />
                      ) : (
                        <div
                          style={{
                            height:
                              pictureBoardData?.userProfilePicture === undefined
                                ? "290px"
                                : "250px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center"
                          }}>
                          {TEXT_NO_PICTURE_ADDED}
                        </div>
                      )}
                      {pictureBoardData?.userProfilePicture ? (
                        <>
                          <CardContent
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                              gap: "20px"
                            }}>
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "10px"
                              }}>
                              <Avatar
                                alt={"User profile Picture"}
                                style={{ height: "40px", width: "40px" }}
                                src={pictureBoardData?.userProfilePicture}
                              />
                              <Typography variant="h6" sx={{ fontSize: "large" }}>
                                {pictureBoardData?.userName}
                              </Typography>
                            </div>
                            <Typography variant="body2">
                              {dayjs(pictureBoardData?.uploadDate).format("MMMM DD, YYYY")}
                            </Typography>
                          </CardContent>
                        </>
                      ) : (
                        <CardContent
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center"
                          }}></CardContent>
                      )}
                    </Card>
                  </Grid>
                )}
              <Grid container size={{ xs: 12, lg: 6, xl: 6 }}>
                {cardData.map((item, index) => (
                  <DashboardCard
                    key={index}
                    title={item.title}
                    count={item.count}
                    onClick={item.onClick}
                    subtitle={item.subtitle}
                    color={selectedClientData?.AccentColor}
                  />
                ))}
              </Grid>
            </Grid>
          </div>

          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginTop: 2
            }}>
            <Typography sx={{ fontWeight: "300", fontSize: 16 }} variant="body2">
              {TEXT_MY_APPLICATIONS}
            </Typography>
            <Stack direction={"row"} sx={{ gap: 1,  alignItems: "center"  }} >
              <Button
                sx={{ color: selectedClientData?.AccentColor }}
                onClick={handleShowEditModule}
                startIcon={<EditIcon size={14} />}>
                {TEXT_EDIT_HOME}
              </Button>

              <Stack direction={"row"} sx={{ gap: 1,  alignItems: "center"  }} >
                <Typography>{`${TEXT_SORT_BY}`}</Typography>
                <Typography
                  variant="body1"
                  sx={{
                    color: selectedClientData?.AccentColor,
                    cursor: "pointer",
                    userSelect: "none"
                  }}
                  onClick={() => handleSetSortBy(!sortBy)}>
                  {sortBy === true ? TEXT_RECENTLY_USED : TEXT_ALPHABETICAL}
                </Typography>
              </Stack>
            </Stack>
          </Box>
          {appLicence?.length > 0 ? (
            <List>
              {pinnedApps?.map((licence, index) => (
                <ListItem
                  onClick={() => handleNavTo(licence.AppName, licence)}
                  style={{
                    marginTop: "10px",
                    alignItems: "center",
                    backgroundColor: "white",
                    borderRadius: "10px"
                  }}
                  key={index}
                  secondaryAction={
                    <Stack direction="row" spacing={1} sx={{ alignItems: "center" }}>
                      {licence.badgeCount !== 0 && (
                        <Badge variant="standard" badgeContent={licence.badgeCount} color="error" />
                      )}
                      {licence.IsPin && (
                        <IconButton edge="end" aria-label="comments" disabled>
                          <PushPinIcon sx={{ color: selectedClientData?.AccentColor }} />
                        </IconButton>
                      )}
                    </Stack>
                  }
                  disablePadding>
                  <ListItemButton
                    sx={{
                      borderRadius: "10px"
                    }}
                    role={undefined}>
                    <ListItemIcon>
                      {whichIcon(licence.AppName, selectedClientData?.AccentColor)}
                    </ListItemIcon>
                    <ListItemText id={licence.id} primary={licence.AppName} />
                  </ListItemButton>
                </ListItem>
              ))}
            </List>
          ) : (
            <Grid sx={{ alignItems: "center",  justifyContent: "center", height: "80vh" }} container>
              <Typography>{TEXT_NO_LICENSES_FOUND}</Typography>
            </Grid>
          )}
        </>
      ) : (
        <Grid sx={{ alignItems: "center",  justifyContent: "center", height: "80vh" }} container>
          <Typography>{TEXT_NO_LICENSES_FOUND}</Typography>
        </Grid>
      )}

      {showEditModule && (
        <ClientHomeEditModal open={showEditModule} handleClose={handleHideEditModule} />
      )}
      {pictureViewerOpen && (
        <PictureViewer
          isOpen={pictureViewerOpen}
          onClose={() => setPictureViewerOpen(false)}
          pictures={[pictureBoardData].map((pic) => ({
            src: pic?.fileUrl,
            alt: pic?.pictureDescription
          }))}
          viewerIndex={pictureViewIndex}
        />
      )}
      <Snackbar
        open={snackbarOpen}
        onClose={() => setSnackbarOpen(false)}
        message={"You dont have licence, Please Contact Your Admin"}
        autoHideDuration={3000}
      />
    </>
  );
}

export default ClientHome;

